import { FileInfo } from "components/dashboard/product-template-table/utils/interfaces";
import { Instant } from "@js-joda/core";
import { DatasetLoadingConf } from "../charts/interfaces";

export type ObjectDatasetDto = ObjectDatasetReq & {
  createdAt: string;
};

export type ObjectDatasetWithDaysDto = ObjectDatasetDto & {
  distinctDays: string[];
};

export type ObjectDatasetReq = {
  identifier: string;
  type: ObjectDatasetType;
  title: string;
};

export type ObjectDatasetDataReq = {
  identifier: string;
  companyRef: string;
  startDate: Instant;
  endDate: Instant;
};

export type ObjectDatasetDataPagedReq = ObjectDatasetDataReq & {
  skip: number;
  take: number;
};

export type ObjectDatasetDataDto = {
  timestamp: string;
  updatedAt: string;
  rootPath: string;
  identifier: string;
  fileInfos: FileInfo[];
};

export const objectDatasetTypes = ["GENERAL", "IMAGE", "JSON", "HTML"] as const;

export type ObjectDatasetType = (typeof objectDatasetTypes)[number];

export type ObjectDatasetConfig = {
  height?: number;
  identifier: string;
  initialFileKey?: string;
  loadConf?: DatasetLoadingConf;
  showDeleteButton?: boolean;
  rows?: number | null;
};
